













































// vendor
import { defineComponent, computed, ref, PropType, watch } from "@vue/composition-api";

import { LoadingBar, Icon, AlertBox } from "@ui";
import { useTranslate } from "@lang";
import { AssetPointer } from "@psychlab/types";
import { Graph } from "@psychlab/types/graph";
import { UpdateReport, getUpdateReport, applyUpdate as applyReport } from "./getUpdateReport";
import * as AssetAPI from "@/services/api/assets";

export default defineComponent({
	emit:[ "updated" ],
	props:{
		reference:{
			type:Object as PropType<AssetPointer<Graph>>,
			required:true,
		},
	},
	components:{
		LoadingBar,
		Icon,
		AlertBox,
	},
	setup(props, ctx){

		const { translate } = useTranslate();
		
		const loading = ref(false);
		const updating = ref(false);

		const didUpdate = ref(false);

		const outdatedRefs = computed(() => {
			return report.value ? report.value.entries.length : 0;
		})

		const report = ref<UpdateReport|null>(null);

		const assetId = computed(() => {
			return props.reference.ref?.asset;
		});

		const versionId = computed(() => {
			return props.reference.ref?.version;
		});

		const refreshReport = async () => {
			if(!assetId.value || !versionId.value ){ return; }
			const v = await AssetAPI.getAssetVersion(assetId.value, versionId.value, "+data");
			if(!v.data){ return; }
			loading.value = true;
			try {
				report.value = await getUpdateReport(assetId.value, versionId.value, v.data);
			}
			catch{}
			loading.value = false;
		};

		const updateMessage = computed(() => {
			return translate("studies.message.onOutdatedReferences").replace("$n", outdatedRefs.value.toString());
		});

		const showUpdateStatus = computed(() => {
			return outdatedRefs.value === 0 && didUpdate.value;
		});

		const showDialog = computed(() => {
			return updating.value === false && outdatedRefs.value > 0;;
		});

		const update = async () => {
			updating.value = true;
			try {
				await applyUpdate();
			}
			catch(err){
				console.log(err.message);
			}
			updating.value = false;
			didUpdate.value = true;
		};


		const applyUpdate = async () => {
			if(!report.value){ return; }
			const ref = await applyReport(report.value);
			ctx.emit("updated", ref);
		};


		watch(() => props.reference.ref?.version, () => {
			
			didUpdate.value = false;

			refreshReport();
		}, { deep:true })


		refreshReport();
		

		return {
			updating,
			updateMessage,
			showUpdateStatus,
			showDialog,
			translate,
			update,
			
		};
	}
});

